






















































import { defineComponent, ref, reactive, watch } from '@vue/composition-api'

type Props = {
  files: string[]
  height: number
}

export default defineComponent({
  name: 'FileView',
  props: {
    files: {
      type: Object,
      default: [],
    },
    height: {
      type: Number,
      default: 100,
    },
  },
  setup(props: Props) {
    const imgSize = ref(100)

    // Drag definition
    const receiptPos = reactive({
      top: 0,
      left: 0,
    })
    const prevPos = reactive({
      top: 0,
      left: 0,
    })
    const isMouseDown = ref(false)
    const receiptRef = ref<HTMLImageElement>()
    const onMouseDown = (event: MouseEvent) => {
      isMouseDown.value = true
      prevPos.left = event.offsetX
      prevPos.top = event.offsetY
    }
    const onMouseMove = (event: MouseEvent) => {
      if (!receiptRef.value || !isMouseDown.value) return
      event.preventDefault()
      const diffX = event.offsetX - prevPos.left
      const diffY = event.offsetY - prevPos.top
      receiptPos.top = receiptPos.top + diffY
      receiptPos.left = receiptPos.left + diffX
    }
    const onMouseUp = () => {
      isMouseDown.value = false
    }

    const resetImgPos = () => {
      imgSize.value = 100
      receiptPos.top = 0
      receiptPos.left = 0
    }

    watch(
      () => props.files,
      () => {
        resetImgPos()
      },
    )

    const zoomOut = () => {
      const newSize = imgSize.value * 0.8
      imgSize.value = newSize < 100 ? 100 : newSize
    }

    const fileIndex = ref(0)
    const goNextFile = () => {
      fileIndex.value =
        props.files.length <= fileIndex.value + 1 ? 0 : fileIndex.value + 1
      resetImgPos()
    }

    return {
      fileIndex,
      goNextFile,
      receiptPos,
      onMouseDown,
      onMouseMove,
      onMouseUp,
      receiptRef,
      imgSize,
      zoomOut,
      resetImgPos,
    }
  },
})
